import React from 'react';
import { useLocation } from 'react-router-dom';
import { AuthGuard } from './AuthGuard';

export interface RequireAuthWrapperProps {
  children: React.ReactNode;
  publicRoutes?: string[];
}

/**
 * Global Authentication Wrapper
 * Protects all routes by default, with explicit exceptions for public routes
 */
export const RequireAuthWrapper: React.FC<RequireAuthWrapperProps> = ({
  children,
  publicRoutes = ['/', '/login', '/signup', '/forgot-password'],
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Check if current path matches any public route
  const isPublicRoute = publicRoutes.some((route) => {
    // Exact match or starts with the route (for nested routes)
    return currentPath === route || currentPath.startsWith(`${route}/`);
  });

  // If it's a public route, render children directly without auth check
  if (isPublicRoute) {
    return <>{children}</>;
  }

  // For all other routes, require authentication
  return <AuthGuard>{children}</AuthGuard>;
};
